import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import BasicError from './BasicError';
import useIsMobile from '../hooks/useIsMobile';
import InputLabel from './InputLabel';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

function SelectField({ control, handleChange, showValidation, options=[] }) {
  const small = useIsMobile();
  const styles = useThemeCustomStyles();
  const selectStyle = styles.SelectField.Select(small);
  const menuItemStyle = styles.SelectField.MenuItem(small);
  const { validation } = control;
  return (
	<Stack spacing={1} sx={{ height: '100%' }} >
		<InputLabel title={control.title} />
	    <Select
			id={control.id}
			value={control.data}
			onChange={handleChange}
			label={control.title}
			size={small ? 'small' : 'medium'}
			sx={selectStyle}
		>
		{options.map((o) => (<MenuItem 
			value={o.code}
			dense
			sx={menuItemStyle}
		>
			{o.text}
		</MenuItem>))}
		</Select>
		{showValidation && !validation.valid && (<BasicError error={validation.text} />)}
	</Stack>
  );
}

export default SelectField;
